<h1 class="mb-2" *ngIf="showComponentAdd == false">
  <mdb-icon fas icon="tasks"></mdb-icon> Visor nota de venta
</h1>

<h1 class="mb-2" *ngIf="showComponentAdd == true">
  <mdb-icon fas icon="tasks"></mdb-icon> Nota de venta
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Ventas</span>
      <span> /</span>
      <span>Nota de venta</span>
    </p>
  </div>
</div>
<!-- Heading -->


<!-- Cabecera de botones -->
<div *ngIf="showComponentAdd == false">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-header justify-content-end" style="border-bottom: 1px solid #dee2e6">
        <div></div>
        <button type="button" mdbBtn color="info" (click)="showAddVenta()" mdbWavesEffect size="sm">
          Agregar
        </button>
      </div>

      <form autocomplete="off" [formGroup]="formHeader">
        <div class="row filtros-body container-fluid">
          <div class="col">
            <div class="md-form">
              <mdb-date-picker #datePicker [inline]="true" name="fechaInicio" formControlName="fechaInicio"
                [placeholder]="'Fecha Desde'" required>
              </mdb-date-picker>
              <label for="fechaInicio">fecha Desde</label>
            </div>

          </div>

          <div class="col">
            <div class="md-form">
              <mdb-date-picker #datePicker [inline]="true" name="fechaHasta" formControlName="fechaHasta"
                [placeholder]="'Fecha Hasta'" required>
              </mdb-date-picker>
              <label for="fechaHasta">fecha Hasta</label>

            </div>

          </div>

          <div class="col">
            <div class="md-form">
              <mdb-select [options]="optionsEstado" formControlName="estado" [multiple]="true" [filterEnabled]="true"
                [highlightFirst]="false" placeholder="Seleccionar Estado"></mdb-select>
              <label>Estado</label>
            </div>
          </div>

          <div class="col">
            <div class="md-form">
              <mdb-select [options]="optionsVendedor" [multiple]="true" formControlName="vendedor"
                [filterEnabled]="true" [highlightFirst]="false" placeholder="Seleccionar Vendedor"></mdb-select>
              <label>Vendedor</label>
            </div>
          </div>

          <div class="col">
            <div class="md-form">
              <mdb-select [options]="optionsComunas" [multiple]="true" formControlName="comuna" [filterEnabled]="true"
                [highlightFirst]="false" placeholder="Seleccionar Comuna"></mdb-select>
              <label>Comuna</label>
            </div>
          </div>

        </div>

        <div class="row filtros-body">
          <div class="col">
            <div class="md-form">
              <input value="" type="text" id="nroNotaVenta" class="form-control" placeholder="000" required #nroDoc
                formControlName="nroNotaVenta" onlyNumbers />
              <label for="nroNotaVenta">Nro. Nota Venta</label>
            </div>
          </div>

          <div class="col">
            <div class="md-form">
              <input value="" type="text" id="nroFactura" class="form-control" placeholder="000" required #nroDoc
                formControlName="nroFactura" onlyNumbers />
              <label for="nroFactura">Nro. Factura</label>
            </div>
          </div>

          <div class="col p-0">
            <div class="d-flex flex-row">
              <div class="md-form" style="max-width: 90px;">
                <input value="" type="text" class="form-control" formControlName="rutCliente" formatRut />
                <label for="rutcliente">RUT Cliente</label>
              </div>
              <button mdbBtn size="sm" type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                (click)="abrirModalSeleccionarCliente()">
                <mdb-icon fas icon="search"></mdb-icon>
              </button>
              <button mdbBtn size="sm" type="button" color="info" mdbWavesEffect
                (click)="abrirModalSeleccionarClienteSeleccionados()" *ngIf="clientes?.length > 0">
                ({{clientes.length | numerico}}) Seleccionados
              </button>
            </div>
          </div>
          <div class="col">
            <div class="md-form">
            </div>
          </div>
          <div class="col">
            <div class="md-form">
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div class="d-sm-flex p-1">
        <button [disabled]="estadoItem === true || notaVentaFacturada > 3" size="sm" mdbBtn type="button" color="danger"
          mdbWavesEffect class="btn btn-sm" (click)="OnDeleteNotaVenta();">
          <mdb-icon fas icon="trash"></mdb-icon> Eliminar
        </button>
        <button [disabled]="estadoItem === true || notaVentaFacturada > 3" size="sm" mdbBtn type="button" color="info"
          mdbWavesEffect class="btn btn-sm" (click)="OnEditNotaVenta()">
          <mdb-icon fas icon="pen"></mdb-icon> Editar
        </button>
        <button [disabled]="estadoItem === true" size="sm" mdbBtn type="button" color="secondary" mdbWavesEffect
          class="btn btn-sm" (click)="OnShowNotaVenta()">
          <mdb-icon fas icon="eye"></mdb-icon> Mostrar
        </button>

      </div>

      <div>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="limpiarfiltros()">
          <mdb-icon fas icon="broom"></mdb-icon>
          Limpiar
        </button>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
          <mdb-icon fas icon="search"></mdb-icon>
          Buscar
        </button>
      </div>
    </div>
  </div>


  <section>
    <div class="card mb-2 wow">
      <div class="card-body">

        <!-- <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner> -->

        <div class="table-responsive">

          <table class="table TablePrincipal table-striped table-hover table-sm align-middle " *ngIf=" listaNotaVenta">
            <thead class="grey lighten-2">
              <tr>
                <!-- <th scope="col" style="justify-content: center;width: 0%;">
                  <mdb-checkbox ></mdb-checkbox>
                </th> -->
                <th scope="col" style="width: 65%;">Nota de venta</th>
                <th scope="col" style="width: 50%;">Factura</th>
                <th scope="col">Origen</th>
                <th scope="col">Fecha</th>
                <th scope="col">Rut</th>
                <th scope="col">Nombre Cliente</th>
                <th scope="col">Vendedor</th>
                <th scope="col">Comuna</th>
                <th scope="col">Total Neto</th>
                <th scope="col">Total Bruto</th>
                <th scope="col" style="text-align: center;">Estado</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngIf="loading">
                <td colspan="100%" style="text-align: center">
                  <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </td>
              </tr>
              <tr *ngIf="!loading && listaNotaVenta?.length === 0">
                <td colspan="100%" style="text-align: center">
                  No se encontró información
                </td>
              </tr>
              <tr *ngFor="let nv of listaNotaVenta; let i = index;" (click)="ClickedRow(i, nv)"
                [class.active]="i == HighlightRow">
                <!-- <td style="justify-content: center;">
                  <mdb-checkbox [checked]="false">
                  </mdb-checkbox>
                </td> -->

                <td>{{nv.folio}}</td>
                <td class="factura-cell" [ngClass]="{'has-factura': tieneFactura(nv.folio_factura)}">
                  <span *ngIf="tieneFactura(nv.folio_factura)" class="factura-text"
                    [attr.title]="obtenerFacturasTexto(nv.folio_factura)">
                    {{obtenerFacturasTexto(nv.folio_factura)}}
                  </span>
                </td>
                <td>
                  <span *ngIf="nv.origen != null">{{nv.origen}}</span>
                  <span *ngIf="nv.origen == null">ERP</span>
                </td>
                <td>{{nv.fecha_emision | fecha}}</td>
                <td>{{nv.rutFormato | rut}}</td>
                <td>{{nv.nombrecliente}}</td>
                <td>{{nv.vendedor_nombre}}</td>
                <td>{{nv.comuna}}</td>
                <td>${{nv.total_neto | numerico}}</td>
                <td>${{nv.total_bruto | numerico}}</td>
                <td style="text-align: center;" [ngClass]="{'colorEstadoDoc' : nv.estado_documento_codigo === 5}">
                  {{nv.estado_documento_nombre}}
                  <mdb-icon *ngIf="nv.observacion_2 && nv.estado_documento_codigo !== 5"
                            fas icon="exclamation-triangle" class="text-warning ml-1"
                            style="cursor: pointer;"
                            (click)="mostrarErrorConversion(nv.observacion_2)">
                  </mdb-icon>
                </td>
                <td style="text-align: center;" [ngClass]="{'colorEstadoDoc' : tieneFactura(nv.folio_factura) || nv.estado_documento_codigo === 5}">
                  {{obtenerEstadoDisplay(nv)}}</td>

              <tr>
              </tr>
            </tbody>
            <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
              *ngIf="listaNotaVenta?.length > 0"></app-pagination>
            <tfoot *ngIf="listaNotaVenta?.length > 0">
              <tr>
                <td colspan="8"></td>
                <td colspan="3" style="font-weight: bold; font-size: 15px; text-align: center;">
                  <span style="color: red;">Total Neto: </span>
                  <span style="font-weight: bold;">${{sumMontoNeto | truncateNumbers}}</span>
                  <span style="margin-left: 30px; color: red;">Total Bruto: </span>
                  <span style="font-weight: bold;">${{sumMontoBruto | truncateNumbers}}</span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </section>


</div>


<!-- MODAL SELECCION DE CLIENTES -->
<app-modal-seleccionar-cliente (onSelectMultiple)="onClienteSeleccionadoMultiple($event)" queryType="ONLY_RUT_BLO_DESB"
  (onSelectSingle)="onClienteSeleccionado($event)">
</app-modal-seleccionar-cliente>

<!-- MODAL DE CONFIRMACION -->
<app-modal-confirm></app-modal-confirm>

<app-add-nota-venta [childMessage]="seleccionNotaVentaEsp" (onSuccess)="OnCloseEditAdd($event)"
  (onSaveNotaVenta)="onUpdateFiltro();"></app-add-nota-venta>
<!--
<app-nota-venta-detalles (onAddProductoRequest)="onAddProductoRequest()"
  (onDeleteProductoRequest)="onDeleteProductoRequest($event)" [permiteUnidadNegocio]="permiteUnidadNegocio"
  [cabeceraComponent]="cabeceraComponent"></app-nota-venta-detalles> -->
